import { combineReducers } from "redux";
import getSnapshotTypeReducer from "./getSnapshotType";

const snapshotTypeDisplayReducer = combineReducers({
    getSnapshotType: getSnapshotTypeReducer,
});

export default snapshotTypeDisplayReducer;